function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPaginationPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-pagination-prev") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Giving-History"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Giving-History---Updated"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-Left-Arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M.36,9.89,7.9,17.63a1.21,1.21,0,0,0,1.74,0,1.28,1.28,0,0,0,0-1.78L3,9,9.64,2.15a1.28,1.28,0,0,0,0-1.78A1.21,1.21,0,0,0,7.9.37L.36,8.11A1.28,1.28,0,0,0,0,9,1.26,1.26,0,0,0,.36,9.89Z",
    transform: "translate(0 0)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPaginationPrev);
export default __webpack_public_path__ + "static/media/arrow-pagination-prev.ac18d936829d9addd27ad98554f8fc77.svg";
export { ForwardRef as ReactComponent };